export default __webpack_public_path__ + "static/media/stuck-veskovic-modernes-badezimmer-4.1215bc81.jpg";